var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign-in",
    transform: "translate(-574.000000, -773.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(553.000000, 630.660000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.206667, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(20.793333, 14.340000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5459375,9.669 L2.989,11.748125 L0.95340625,11.7911875 C0.3450625,10.6628438 0,9.371875 0,8 C0,6.67340625 0.322625,5.42240625 0.8945,4.320875 L0.8949375,4.320875 L2.7071875,4.653125 L3.5010625,6.4545 C3.33490625,6.93890625 3.24434375,7.45890625 3.24434375,8 C3.24440625,8.58725 3.35078125,9.14990625 3.5459375,9.669 Z",
    id: "Path",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8602187,6.5055 C15.9520937,6.9894375 16,7.48921875 16,8 C16,8.57275 15.9397812,9.1314375 15.8250625,9.67034375 C15.435625,11.5041875 14.4180312,13.1055 13.008375,14.2386875 L13.0079375,14.23825 L10.7253125,14.1217813 L10.40225,12.1050625 C11.337625,11.5565 12.068625,10.6980313 12.4536875,9.67034375 L8.175875,9.67034375 L8.175875,6.5055 L12.5160937,6.5055 L15.8602187,6.5055 L15.8602187,6.5055 Z",
    id: "Path",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0079062,14.23825 L13.0083437,14.2386875 C11.637375,15.3406563 9.8958125,16 8,16 C4.95340625,16 2.304625,14.2971563 0.95340625,11.7912187 L3.5459375,9.66903125 C4.22153125,11.4720937 5.960875,12.755625 8,12.755625 C8.87646875,12.755625 9.69759375,12.5186875 10.4021875,12.1050625 L13.0079062,14.23825 Z",
    id: "Path",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.106375,1.84175 L10.5147188,3.9635 C9.7855,3.5076875 8.9235,3.244375 8,3.244375 C5.91471875,3.244375 4.14284375,4.58678125 3.50109375,6.4545 L0.8949375,4.320875 L0.8945,4.320875 C2.2259375,1.75384375 4.908125,0 8,0 C9.94109375,0 11.720875,0.6914375 13.106375,1.84175 Z",
    id: "Path",
    fill: "#F14336"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.622d1cdf.svg";
export { ForwardRef as ReactComponent };